/**
 * Путь страницы подтверждения почты. Общий для обеих сторон: сервер собирает
 * по нему ссылку в письме (server/auth/emailVerification.js), клиент по нему же
 * распознает возврат из письма (src/App.js).
 *
 * Ссылка ведет НА САЙТ, а не прямо в API: почтовые клиенты и антивирусы
 * заранее ходят по ссылкам из писем, и ручка, срабатывающая на GET, «сгорала»
 * бы до того, как человек нажмет. Страница сайта уже сама отправляет токен
 * в API методом POST.
 */
export const EMAIL_CONFIRM_URL_PREFIX = '/auth/confirm/';

/**
 * Путь страницы задания нового пароля. Та же логика, что и у подтверждения:
 * ссылка ведет на сайт, страница отправляет токен в API методом POST.
 */
export const PASSWORD_RESET_URL_PREFIX = '/auth/reset/';
